export function convertBasketItemsToString(basketItems: Array<any>) {
    let newValue = "";
    basketItems.forEach((bi: any) => {
        newValue += bi.meta?.title;
        newValue = (basketItems[basketItems.length - 1].id !== bi.id) ? newValue + ' | ' : newValue
    });
    return newValue;
}